export enum Types {
	CONSULTAR_CIN_PPT_REQUEST = '@iirgd/CONSULTAR_CIN_PPT_REQUEST',
	CONSULTAR_CIN_PPT_SUCCESS = '@iirgd/CONSULTAR_CIN_PPT_SUCCESS',
	CONSULTAR_CIN_PPT_FAILURE = '@iirgd/CONSULTAR_CIN_PPT_FAILURE',
	CONSULTAR_CIN_PPT_CLEAR = '@iirgd/CONSULTAR_CIN_PPT_CLEAR',
}

export interface ConsultarCinPPTState {
	status: number;
	data: ConsultarCinPPTResponse | null;
	dataFailure: ConsultarCinPPTFailureResponse | null;
}

export interface ConsultarCinPPTResponse {
	messageClassName: string;
	postoEmissor: string;
	dataInclusao: string;
	dataAlteracao: string;
	dataEmissao: string;
	tipoGrafico: string;
	cinImagem: string;
	cinQrCode: string;
	codMrzPassaporte: string;
	prtValidImagem: string;
	indicadorConsistenciaBiografica: string;
	indicadorConsistenciaBiometrica: string;
	situacao: string;
	situacaoDescricao: string;
	situacaoSerpro: string;
	codigoHashRfb: string;
	protocoloRfb: string;
	dataProtocoloRfb: string;
	cpf: string;
	registroNumero: string;
	registroDigito: string;
	registroSequencia: string;
	usuarioAlteracao: string;
	usuarioAlteracaoCpf: string;
	usuarioInclusao: string;
	usuarioInclusaoCpf: string;
	observacao: string;
	status: string;
	statusMensagem: string;
	interMensagem: string;
	messageType: string;
}

export interface ConsultarCinPPTRequest {
	usuario: IUsuario;
	cpf: string;
	digitoCpf: string;
	registroNumero: string;
	registroDigito: string;
	registroSequencia: string;
}

export interface ConsultarCinPPTFailureResponse {
	status: number;
	trace: string;
	messages: string[];
}

export interface IUsuario {
	usuario: string;
	senha: string;
}
